const Button = ({
    title,
    isDisabled = false,
    onClick,
    type = "button",
}: {
    title: string;
    isDisabled: boolean;
    onClick?: () => void;
    type: "button" | "submit"
}) => {
    return <button 
        className={`mb-[calc(80px)] ${isDisabled ? "bg-gray-300 text-white" : "bg-black hover:bg-transparent hover:text-black text-principal"} border p-2 rounded-lg h-[calc(60px)] w-full`}
        type={type}
        disabled={isDisabled}
        onClick={isDisabled ? () => null : onClick}>
        {title}
    </button>;
}

export default Button;